import React, { useEffect, useState } from 'react'
import { ScrollView, Text, View } from 'react-native'
import { getMediaStreaming } from '../../../Redux/Actions/tvRemoteAction';
import TVRemote_Potrait from './TVRemote_potrait';
import { useCssStyle } from '../../../customHook/getCssStyle';
import CustomPressable from '../../../components/customPressable/customPressable';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import HeaderWithBack from '../../../components/Header/headerWithBack';
import { ImageComp } from '../../../components/Image/Image';
import { getCleanUrl } from '../../../utils/Helper';
import Loader from '../../../components/Loader/loader';
import { TV } from '../../../assets';
import TVChannels_Potrait from './TVChannels_potrait';

const Remote_Potrait = (props) => {
  const { loading, initialiseRemote, handleRefreshToken, sendCommand, clickChannel, handleMedialStreaming } = props;

  const getStyles = useCssStyle();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { currentWidget } = useSelector((state) => state.deviceConfigSlice);
  const { isRoomRemoteLoading, isChannelDataLoading, isMediaListLoading, currentTv, roomRemoteDetails, mediaList } = useSelector(state => state.tvRemoteSlice);

  const [currentPage, setCurrentPage] = useState(0);

  useEffect(()=> {
    if(currentTv?.deviceType === "APPLETV") {
      setCurrentPage(0);
    }

  }, [currentTv?.deviceType])

  

  return (
    <View style={getStyles(['widgetRootContainer', 'tvRemoteRootContainer_potrait'])} id='tvRemoteRootContainer_potrait'>
      <HeaderWithBack />

      <View style={getStyles(['widgetmainContainerHeaderContainer', 'tvRemoteHeaderContainer_potrait'])} id='tvRemoteHeaderContainer_potrait'>
        {
          currentWidget?.widgetHeaderImageUrl && 
            <ImageComp
                source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} 
                style={getStyles(['widgetmainContainerHeaderImg', 'tvRemoteHeaderImg_potrait'])} id={"tvRemoteHeaderImg_potrait"}
            />
        }
        <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'tvRemoteHeaderTitleContainer_potrait'])} id='tvRemoteHeaderTitleContainer_potrait'>
          <Text style={getStyles(['widgetmainContainerHeaderTitle', 'tvRemoteHeaderTitle_potrait'])} id='tvRemoteHeaderTitle_potrait'>
            {t("room_control.tv_control.header")}
          </Text>
        </View>
      </View>

      <View style={getStyles(["tvRemoteFilterPillContainer"])} id="tvRemoteFilterPillContainer">
        <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={getStyles(['tvRemoteFilterContainer'])} id="tvRemoteFilterContainer" style={{ width: '100%' }}>
          {[
            t('room_control.tv_control.remote_btn'), 
            t('room_control.tv_control.guide_btn')
          ].map((iterator, index) => (
            <CustomPressable 
              key={index} 
              onPress={() => setCurrentPage(index)} 
              style={getStyles(['tvRemoteFooterButtonItemContainer_potrait', currentPage == index && 'tvRemoteFooterActiveContainer_potrait'])} 
              id={`tvRemoteFooterButtonItemContainer_potrait tvRemoteFooterActiveContainer_potrait`}
              disabled={!roomRemoteDetails?.length}
            >
              <Text 
                style={getStyles(['tvRemoteFooterButton_potrait', currentPage == index && 'tvRemoteFooterActiveButton_potrait'])} 
                id={`tvRemoteFooterButton_potrait tvRemoteFooterActiveButton_potrait`}
              >
                {iterator}
              </Text>
            </CustomPressable>
          ))}
        </ScrollView>
      </View>
      <ScrollView
        automaticallyAdjustKeyboardInsets={true} 
        contentContainerStyle={getStyles(['widgetmainContainer', 'tvRemoteMainContainer_potrait'])} 
        showsVerticalScrollIndicator={false}
        id='tvRemoteMainContainer_potrait'
      >

        <View style={getStyles(['widgetmainContainerChildContainer', 'tvRemoteContainerChildContainer'])} id='tvRemoteContainerChildContainer'>


          
          {currentPage===0 && <View style={getStyles(["mediaDeviceListMainContainer_potrait"])} id='mediaDeviceListMainContainer_potrait'>
            {
              isMediaListLoading ? 
                <View style={getStyles(['mediaDeviceListContainer_loader_potrait'])}>
                  <Loader size={'small'} style={getStyles(['mediaDeviceList_loader_potrait'])}/> 
                </View>

              : mediaList?.length < 1 && roomRemoteDetails?.length ? <CustomPressable onPress={() => dispatch(getMediaStreaming())} style={getStyles(['primaryBtn'])}>
                  <Text style={getStyles(['primaryBtnTxt'])}>{
                    t("room_control.tv_control.media_not_available")
                  }</Text>
                </CustomPressable>
              : mediaList?.map((iterator, index) => {
                return <CustomPressable style={getStyles(["mediaDeviceListContainer_potrait"])} onPress={() => handleMedialStreaming([iterator?.mediaName])} id="mediaDeviceListContainer_potrait">
                  {iterator?.imageUri ? <ImageComp source={getCleanUrl(iterator?.imageUri)} style={getStyles(["mediaDeviceImageContainer_potrait"])} id="mediaDeviceImageContainer_potrait" /> : <Text style={getStyles(["mediaDeviceText_potrait"])} id='mediaDeviceText_potrait'>TV {index+1}</Text>}

                  <View style={getStyles(["mediaDeviceTextContainer_potrait"])} id='mediaDeviceTextContainer_potrait'>
                    <Text style={getStyles(["mediaDeviceText_potrait"])} id='mediaDeviceText_potrait'>
                      {iterator?.mediaName}
                    </Text>
                  </View>

                </CustomPressable>
              })}

              {!roomRemoteDetails?.length && !loading && <View style={getStyles(['tvRemoteFallbackContainer_potrait'])} id='tvRemoteFallbackContainer_potrait'>
                    <ImageComp
                        source={TV}
                        style={getStyles(["tvRemoteFallbackImage_potrait"])} 
                        id='tvRemoteFallbackImage_potrait'
                    />

                    <CustomPressable onPress={handleRefreshToken} style={getStyles(['primaryBtn'])} id='primaryBtn'>
                        <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>No TV is connected, retry?</Text>
                    </CustomPressable>
                </View>}
          </View>
          }
          {currentPage===1 && <TVChannels_Potrait clickChannel={clickChannel} {...props} />}

        </View>
        
        {roomRemoteDetails?.length && <TVRemote_Potrait initialiseRemote={initialiseRemote} sendCommand={sendCommand} />}
        
      </ScrollView>

    </View>
  )
}

export default Remote_Potrait
